import { motion } from "framer-motion";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong, faHospital, faPills, faUserDoctor, faHeartPulse } from "@fortawesome/free-solid-svg-icons";
import "./MissionSection.scss";

const values = [
  { icon: faUserDoctor, key: "pharmacist" },
  { icon: faPills,      key: "database" },
  { icon: faHospital,   key: "local_data" },
  { icon: faHeartPulse, key: "impact" },
];

const MissionSection = () => {
  const { t, i18n } = useTranslation();
  return (
    <section className="syd-mission">
      <div className="container">
        <div className="syd-mission__inner">

          {/* ── Left ── */}
          <motion.div
            className="syd-mission__content"
            initial={{ opacity: 0, x: -28 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <div className="syd-mission__label">{t("landing.mission.label")}</div>
            <h2 className="syd-mission__title">
              {t("landing.mission.title_pre")}
              <span> {t("landing.mission.title_accent")}</span>
            </h2>
            <p className="syd-mission__text">
              <Trans i18nKey="landing.mission.text" components={{ 1: <strong /> }} />
            </p>
            <a href={`/${i18n.language}/register`} className="syd-mission__cta">
              {t("landing.mission.cta")}
              <FontAwesomeIcon icon={faArrowRightLong} />
            </a>
          </motion.div>

          {/* ── Right — values grid ── */}
          <div className="syd-mission__values">
            {values.map((v, i) => (
              <motion.div
                className="syd-mission__value"
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                viewport={{ once: true }}
              >
                <div className="syd-mission__value-icon">
                  <FontAwesomeIcon icon={v.icon} />
                </div>
                <div>
                  <div className="syd-mission__value-title">{t(`landing.mission.${v.key}_title`)}</div>
                  <div className="syd-mission__value-desc">{t(`landing.mission.${v.key}_desc`)}</div>
                </div>
              </motion.div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default MissionSection;
